// eslint-disable-next-line unicorn/prefer-module
const windowUrl = require('./windowUrl');

const PREFIX_REGEX = /^https?:\/\/[^/]+(\/(fr)?)/;

const getRelativePrefix = (requestUrl) => {
  const url = requestUrl || windowUrl;
  const [, prefix] = url.match(PREFIX_REGEX) || [];
  return prefix;
};

// eslint-disable-next-line unicorn/prefer-module
module.exports = getRelativePrefix;
